import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { saveToGlobalState } from "../../utils/localStorage";

const API_URL = process.env.REACT_APP_API_URL;

export default function UseCreateTripNegotiations() {
  const navigate = useNavigate();
  const { authFetch, user, setShowLoginModal } = useAuth();
  const [loadingId, setLoadingId] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const buyTrip = async (trip) => {
    try {
      setLoadingId(trip.id || trip.serie_viagem);
      setError("");
      setSuccess("");

      //console.log(trip);
      //return;

      const payload = {
        serie_trip: trip.serie_viagem,
        serie_receiver: null,

        order_value: trip.preco_estimado_formatado
          ? String(trip.preco_estimado_formatado)
          : null,
        insurance_amount: trip.insurance_amount || null,
        client_order_type: trip.client_order_type || null,
      };

      if (!user?.serie) {
        saveToGlobalState({
          voltando_trajeto: "nao",
          tab_login: "COMPRAR",
          payload: payload,
        });
        setShowLoginModal(true);
        return;
      }

      const response = await authFetch(
        `${API_URL}/api/create-trip-negotiations/`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            // ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.detail || "Erro ao criar negociação.");
      }
      console.log(response);
      setSuccess(data.detail || "Negociação criada com sucesso.");
      navigate("/dashboard-client");
      return data;
    } catch (err) {
      setError(err.message || "Erro inesperado.");
      throw err;
    } finally {
      setLoadingId(null);
    }
  };

  return {
    buyTrip,
    loadingId,
    loading: Boolean(loadingId),
  };
}
